import { useMemo } from 'react';

import useGet from 'lib/hooks/useGet';
import { STATS_UPB_MATCH_PARTNER } from 'lib/networking/endpoints';

/**
 * useUpbMatchPartnerTrend — fetches per-metric daily history for one partner.
 *
 * Changing `range` re-fetches automatically.
 * Returns { data, loading, error, refetch }
 * data shape: { entity_id, range, series: { <METRIC_KEY>: [{ date, value }] } }
 */
function useUpbMatchPartnerTrend({ entityId, range = '7d', skip = false } = {}) {
  const url = entityId ? `${STATS_UPB_MATCH_PARTNER}/${entityId}/trend` : STATS_UPB_MATCH_PARTNER;
  const params = useMemo(() => ({ range }), [range]);
  return useGet(url, params, skip || !entityId);
}

export default useUpbMatchPartnerTrend;
